import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';

import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import global_axios from '../../funciones_globales/interaccionapi';
import { formatearNumeroDecimal, formatearFechaMoment_a_String, formatearFechaMoment_a_StringFormatoReporte } from '../../funciones_globales/format';
import { cargarCatalogoEstados } from '../../funciones_globales/catalogos';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';

import { cargarAsiento } from '../../actions/contabilidad/act_con01';
import BusquedaCtaContable from './busquedaCtaContable';
import { seleccionar_CuentaContable } from '../../actions/contabilidad/act_busquedaCtaContable';

import { LabelForm, LabelNota } from '../componentes_generales/componentes_formulario/labels/';
import { InputText } from '../componentes_generales/componentes_formulario/inputs/inputtext';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import ModalResponsive from '../componentes_generales/componentes_formulario/modals/modalresponsive';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';

const ContainerRadio = styled.div`
	margin-top: 22px;
`;

const PaginationLabels = styled.div`
    font-size: 12px;
`;

const PaginationButtons = styled.div`
    margin-bottom:10px;
`;

const LabelTotales = styled.label`
	display: inline-block;
	font-size: 10px;
	color: green;
`;

const LabelValorTotales = styled.label`
	display: inline-block;
	font-size: 9px;
	font-weight: bold;
	align-text: right;
`;

const Hr = styled.hr`
	margin-top: 10px;
	margin-bottom: 10px;
`;

const ModalContainer = styled.div`
	margin-top: 20px;
	height: 400px;
	width: 700px;
`;

const ValueForm = styled.span`
	display: inline-block;
	font-size: 12px;
`;

class FormCon02 extends React.Component{
    constructor(props) {
		super(props);
		
		this.state = {
			isConsultar: false,
			planContable: getItemDatosSesion('planVigente'),
			fechaDesde: null,
			fechaHasta: null,
			mayorizado: 'T',
			mayorAnalitico: [],
			totalDebito: 0,
			totalCredito: 0,
			totalSaldo: 0,
			saldoAnterior: 0,
			isModalAsientoVisible: false,
			pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
			columnDefs: [
				{
					header: "No.",
					field: "NroItem",
					width: 30,
					type: "string",
					suppressFilter: true
				},
				{
					header: "Fecha",
					field: "Fecha",
					width: 80,
					type: "string",
					suppressFilter: true
				},
				{
					header: "Asiento",
					field: "Movimiento",
					width: 80,
					type: "string"
				},
				{
					header: "Tipo",
					field: "Tipo",
					width: 60,
					type: "string"
				},
				{
					header: "Comprobante",
					field: "Comprobante",
					width: 90,
					type: "string"
				},
				{
					header: "Concepto",
					field: "Concepto",
					width: 310,
					type: "string"
				},
				{
					header: "Débito",
					field: "Debito",
					width: 90,
					type: "num_decimal",
					suppressFilter: true
				},
				{
					header: "Crédito",
					field: "Credito",
					width: 90,
					type: "num_decimal",
					suppressFilter: true
				},
				{
					header: "Saldo",
					field: "Saldo",
					width: 90,
					type: "num_decimal",
					suppressFilter: true
				}
			],
			asiento_movimiento: '',
			asiento_tipo: '',
			asiento_comprobante: '',
			asiento_fecha: '',
			asiento_usuario: '',
			asiento_totalDebe: 0,
			asiento_totalHaber: 0,
			asiento_estados: [],
			asiento_estadoSel: 'P',
			asiento_estadoLabel: '',
			asiento_data: [],
			asiento_columnDefs: [
				{
					header: "No.",
					field: "NroItem",
					width: 30,
					type: "string",
					suppressFilter: true
				},
				{
					header: "Cuenta",
					field: "Cuenta",
					width: 100,
					type: "string",
					suppressFilter: true
				},
				{
					header: "Nombre cuenta",
					field: "NombreCuenta",
					width: 228,
					type: "string",
					suppressFilter: true
				},
				{
					header: "Débito",
					field: "Debito",
					width: 70,
					type: "num_decimal",
					suppressFilter: true
				},
				{
					header: "Crédito",
					field: "Credito",
					width: 70,
					type: "num_decimal",
					suppressFilter: true
				},
				{
					header: "Detalle",
					field: "Concepto",
					width: 230,
					type: "string",
					editable: true
				},
			]
		};

		this.gridMayorAnaliticoOptions = {
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
			rowSelection: "single",
			paginationAutoPageSize:true,
            pagination: true,
            suppressPaginationPanel: true,
            suppressScrollOnNewData: true,
			onPaginationChanged: () => {
                if(!this.gridMayorAnaliticoApi){
                    return;
                }
                let totalFilas = this.gridMayorAnaliticoApi.paginationGetRowCount();
                let totalFilasPorPagina = this.gridMayorAnaliticoApi.paginationGetPageSize();
                let ultimaFilaPagina = (totalFilasPorPagina * (this.gridMayorAnaliticoApi.paginationGetCurrentPage()+1));
                let indexPage = this.gridMayorAnaliticoApi.paginationGetCurrentPage();

                if( ultimaFilaPagina >  totalFilas){
                    ultimaFilaPagina = totalFilas;
                }
                let pagination = {
                    totalFilas: totalFilas,
                    totalFilasPorPagina: totalFilasPorPagina,
                    primaraFilaPagina: (totalFilasPorPagina * (indexPage + 1) - totalFilasPorPagina + 1),
                    ultimaFilaPagina: ultimaFilaPagina
                };

                this.setState({pagination});
			},
			onRowDoubleClicked: event => {
				let movimiento = event.data.Movimiento;
				this.getAsientoById(movimiento);
				this.setState({isModalAsientoVisible: true});
			  },
		};

		this.gridAsientoOptions = {
			enableColResize: true,
			enableSorting: true,
			enableFilter: true,
			rowSelection: "single",
		};

		this.handleInputChange = this.handleInputChange.bind(this);
		this.consultarDatos = this.consultarDatos.bind(this);
		this.onGridReady = this.onGridReady.bind(this);
		this.limpiarDatos = this.limpiarDatos.bind(this);
		this.copiarCtaContable = this.copiarCtaContable.bind(this);
		this.onGridAsientoReady = this.onGridAsientoReady.bind(this);
		this.getAsientoById = this.getAsientoById.bind(this);
		this.validarFiltros = this.validarFiltros.bind(this);
		this.limpiarGrid = this.limpiarGrid.bind(this);
		this.imprimirComprobante = this.imprimirComprobante.bind(this);
		this.imprimirAsiento = this.imprimirAsiento.bind(this);
		this.handleConsultaClick = this.handleConsultaClick.bind(this);
		this.handleImprimirClick = this.handleImprimirClick.bind(this);
	}

	componentDidMount(){
		Promise.all([
			cargarCatalogoEstados('ConMovimiento', 'Status'),
			this.props.generar_LogAuditoriaIngresoForm('0802'),
		])
		.then(([asiento_estados]) => {			
			this.setState({asiento_estados});
		})
		.catch(error => {
			alert(error.response?error.response.data.msg:error.message);
		});
	}

	componentWillUnmount(){
		this.props.generar_LogAuditoriaSalidaForm('0802');
	}

	onGridReady(params) {
		this.gridMayorAnaliticoApi = params.api;
		this.gridMayorAnaliticoColumnApi = params.columnApi;
	}

	onGridAsientoReady(params) {
		this.gridAsientoApi = params.api;
		this.gridAsientoColumnApi = params.columnApi;
	}

	handleInputChange(event){    
		const target = event.target;       
		const name = target.name;    
		const value = target.type === 'checkbox' ? target.checked : target.value;
		this.setState({
			[name]: value
		});
	}

	copiarCtaContable(){
		this.props.seleccionar_CuentaContable({key:1, cuenta:{
			value: this.props.cuentaContable_sel1.value,
			label: this.props.cuentaContable_sel1.label}
		});
	}

	limpiarGrid(){
		this.setState({
			mayorAnalitico:[],
			totalDebito: 0,
			totalCredito: 0
		});
	}

	limpiarDatos(){
		this.props.seleccionar_CuentaContable({key: 0, cuenta: null});
		this.props.seleccionar_CuentaContable({key: 1, cuenta: null});
		this.setState({
			planContable: getItemDatosSesion('planVigente'),
			fechaDesde: null,
			fechaHasta: null,
			mayorizado: 'T',
			mayorAnalitico: [],
			totalDebito: 0,
			totalCredito: 0,
			totalSaldo: 0,
			isModalAsientoVisible: false,
			pagination: {
                totalFilas: 0,
                totalFilasPorPagina: 0,
                primaraFilaPagina: 0,
                ultimaFilaPagina: 0,
            },
			asiento_movimiento: '',
			asiento_tipo: '',
			asiento_comprobante: '',
			asiento_fecha: '',
			asiento_estadoSel: 'P',
			asiento_estadoLabel: '',
			asiento_data: [],
		});
	}

	validarFiltros(){
		if( !this.state.fechaDesde ){
			alert("No ha especificado el campo: Fecha Desde");
			return false;
		}

		if( !this.state.fechaHasta ){
			alert("No ha especificado el campo: Fecha Hasta.");
			return false;
		}

		let fechaDesde = moment(this.state.fechaDesde);
		let anioDesde = fechaDesde.format('YYYY');
		let mesDesde = fechaDesde.format('M');

		let fechaHasta = moment(this.state.fechaHasta);
		let anioHasta = fechaHasta.format('YYYY');
		let mesHasta = fechaHasta.format('M');

		if( anioDesde !== anioHasta ){
			alert("Las fechas Desde y Hasta deben ser del mismo año.");
			return false;
		}

		if( this.props.cuentaContable_sel1 && this.props.cuentaContable_sel2 ){
			if( this.props.cuentaContable_sel1.value === this.props.cuentaContable_sel2.value ){
				if( mesDesde !== mesHasta ){
					alert("Las fechas Desde y Hasta deben ser del mismo mes.");
					return false;
				}
			}
		}

		return true;
	}

	handleConsultaClick(){
		this.limpiarGrid();

		if( !this.validarFiltros() ){
			return;
		}

		if( this.props.cuentaContable_sel1 && this.props.cuentaContable_sel2 ){
			if( this.props.cuentaContable_sel1.value !== this.props.cuentaContable_sel2.value ){
				alert("Opción disponible para una sola cuenta");
			}else{
				this.consultarDatos();
			}
		}else{
			alert("Opción disponible para una sola cuenta");
		}
	}

	handleImprimirClick(){
		let fDesde = formatearFechaMoment_a_StringFormatoReporte(moment(this.state.fechaDesde));
		let fHasta = formatearFechaMoment_a_StringFormatoReporte(moment(this.state.fechaHasta));
		let Cta1 = this.props.cuentaContable_sel1;
		let Cta2 = this.props.cuentaContable_sel2;

		let qs = "&rpt=29";
		qs += "&param1=" + fDesde;
		qs += "&param2=" + fHasta;
		qs += (Cta1?"&param3="+Cta1.value:"");
		qs += (Cta2?"&param4="+Cta2.value:"");

		visualizarReporteEnPdf(qs);
	}

	consultarDatos(){
		this.props.cambiar_VisualizacionLoading(true);
		let QueryString = "";
		QueryString += "?PlanCuenta="+this.state.planContable;
		QueryString += "&FechaDesde="+formatearFechaMoment_a_String(this.state.fechaDesde);
		QueryString += "&FechaHasta="+formatearFechaMoment_a_String(this.state.fechaHasta);
		QueryString += (this.props.cuentaContable_sel1?"&CuentaDesde="+this.props.cuentaContable_sel1.value:"");
		QueryString += (this.props.cuentaContable_sel2?"&CuentaHasta="+this.props.cuentaContable_sel2.value:"");
		QueryString += "&Mayorizado="+this.state.mayorizado;

        global_axios({
            method: 'GET',
            url: '/diarios/' + QueryString
        })
        .then( response => {
			let mayorAnalitico = [];
			let data = response.data;
			let saldoAnterior = (data[0]?data[0].SaldoInicial:0);
			let saldo = parseFloat(saldoAnterior);
			let totalDebito = 0;
			let totalCredito = 0;
			let totalSaldo = 0;

			data.forEach((item, i) => {
				let isDebe = (item.DebeHaber==='D');
				let vDebito = parseFloat(isDebe?item.Valor:0);
				let vCredito = parseFloat(!isDebe?item.Valor:0);
				saldo = Math.round((saldo + vDebito - vCredito) * 100) / 100;
				totalDebito += vDebito;
				totalCredito += vCredito;
				totalSaldo += saldo;

				mayorAnalitico.push({
					...item,
					NroItem: (i+1),
					Fecha: item.Fecha,
					Comprobante: item.Comprobante,
					Debito: vDebito,
					Credito: vCredito,
					Saldo: saldo
				});
			});
			this.setState({
				mayorAnalitico,
				totalDebito,
				totalCredito,
				totalSaldo,
				saldoAnterior
			});
            this.props.cambiar_VisualizacionLoading(false);
        })
        .catch( error => {
        	this.props.cambiar_VisualizacionLoading(false);			
			alert(`Ha ocurrido un error: ${error.response?error.response.data.msg:error.message}`);
        });
	}

	getAsientoById(asiento_id){
		let asiento = asiento_id;

		if( asiento ){
			this.props.cargarAsiento(asiento).then(
				() => {
					let asiento_data = [];
					let asiento_totalDebe = 0;
					let asiento_totalHaber = 0;
					this.props.asientoContable.detAsiento.forEach((itemAsiento, i) => {
						let isDebe = itemAsiento.DebeHaber==="D";
						asiento_totalDebe += parseFloat(isDebe?itemAsiento.Valor:0);
						asiento_totalHaber += parseFloat(!isDebe?itemAsiento.Valor:0);
						asiento_data.push({
							...itemAsiento,
							NroItem: (i+1),
							Debito: parseFloat(isDebe?itemAsiento.Valor:0),
							Credito: parseFloat(!isDebe?itemAsiento.Valor:0)
						});
					});

					let asiento_movimiento = this.props.asientoContable.Movimiento;
					let asiento_tipo = this.props.asientoContable.Tipo;
					let asiento_comprobante = this.props.asientoContable.Comprobante;
					let asiento_fecha = formatearFechaMoment_a_String(moment(this.props.asientoContable.Fecha,'YYYY-MM-DD'));
					let asiento_estadoSel = this.props.asientoContable.Status;
					let asiento_usuario = this.props.asientoContable.Usuario;

					let asiento_estadoLabel = "";
					this.state.asiento_estados.forEach(item => {
						if( item.value === asiento_estadoSel ){
							asiento_estadoLabel = item.label;
						}
					});

					this.setState({
						asiento_data,
						asiento_movimiento,
						asiento_tipo,
						asiento_comprobante,
						asiento_fecha,
						asiento_estadoSel,
						asiento_estadoLabel,
						asiento_usuario,
						asiento_totalDebe,
						asiento_totalHaber,
					});
				}
			);
		}else{
			alert("El campo número de asiento no ha sido especificado");
		}
	}

	imprimirComprobante(){
		let NroComprobante = this.props.asientoContable.Comprobante;
		let qs = "?TipoAsiento=" + this.props.asientoContable.Tipo;

		global_axios({
            method: 'GET',
            url: '/reportes' + qs
        }).then(
			reportes => {
				let rpt = reportes.data[0];				
				visualizarReporteEnPdf('&rpt=' + rpt.CodigoReporte + '&param1=' + NroComprobante);
			},
			err => {
				if(err.response.status){
					alert("No se encontró el reporte del comprobante relacionado con este asiento.");
				}
			}
		).catch( error => {
            alert("Ha ocurrido un error: " + error);
        });
	}

	imprimirAsiento(){
		let NroMovimiento = this.state.asiento_movimiento;
		visualizarReporteEnPdf('&rpt=27&param1=' + NroMovimiento);
	}

	render(){
		return(
			<ContenedorForm porc_ancho={70}>
				<HeaderForm>
					<TituloForm>Mayor analítico</TituloForm>
				</HeaderForm>				
				<CuerpoForm>
					<Row>
						<ContainerCol className="col-sm-2">
							<LabelForm>Plan contable: </LabelForm>
							<InputText name="planContable" value={this.state.planContable} onChange={this.handleInputChange} autoComplete='off'/>
						</ContainerCol>
						<ContainerCol className="col-sm-5">
							<LabelForm>Cta. Desde: </LabelForm>
							<BusquedaCtaContable id={0} planVigente={this.state.planContable} onChangeCallback={() => this.copiarCtaContable()}
							></BusquedaCtaContable>
						</ContainerCol>
						<ContainerCol className="col-sm-5">
							<LabelForm>Cta. Hasta: </LabelForm>
							<BusquedaCtaContable id={1} planVigente={this.state.planContable}></BusquedaCtaContable>
						</ContainerCol>
					</Row>
					<Row>
						<ContainerCol className="col-sm-2">
							<LabelForm>Fecha desde:</LabelForm>
							<PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fechaDesde)=>{this.setState({fechaDesde})}} />
						</ContainerCol>

						<ContainerCol className="col-sm-2">
							<LabelForm>Fecha hasta:</LabelForm>
							<PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fechaHasta)=>{this.setState({fechaHasta})}} />
						</ContainerCol>

						<ContainerCol className="col-sm-5">
							<ContainerRadio>
								<LabelForm className='radio-inline'>
									<input type="radio" name="mayorizado" value="T" checked={this.state.mayorizado==="T"} onChange={this.handleInputChange} />
									Todos
								</LabelForm>

								<LabelForm className='radio-inline'>
									<input type="radio" name="mayorizado" value="S" checked={this.state.mayorizado==="S"} onChange={this.handleInputChange} />
									Mayorizado
								</LabelForm>

								<LabelForm className='radio-inline'>
									<input type="radio" name="mayorizado" value="N" checked={this.state.mayorizado==="N"} onChange={this.handleInputChange} />
									No mayorizado
								</LabelForm>
							</ContainerRadio>
						</ContainerCol>
					</Row>

					<Row>
						<ContainerCol className="col-sm-12">
							<br />
							<div className="btn-group btn-group-sm" role="group" aria-label="...">
								<button type="button" className="btn btn-primary" onClick={this.handleConsultaClick}>
									<i className="fa fa-search fa-fw"></i>Consultar
								</button>
								<button type="button" className="btn btn-default" onClick={this.handleImprimirClick}>
									<i className="fa fa-print fa-fw"></i>Imprimir
								</button>
								<button type="button" className="btn btn-default" onClick={this.limpiarDatos}>
									<i className="fa fa-trash fa-fw"></i>Limpiar
								</button>
							</div>
						</ContainerCol>
					</Row>

					<Row>
						<ContainerCol className="col-sm-12">
							<AgGridRender
								altura='281px'
								data={this.state.mayorAnalitico}
								columnas={this.state.columnDefs}
								onGridReady={this.onGridReady}
								gridOptions={this.gridMayorAnaliticoOptions}
							/>
						</ContainerCol>
					</Row>

					<Row>
						<ContainerCol className='col-sm-12'>
							<LabelNota>* Doble click en la fila para ver el asiento contable.</LabelNota>
						</ContainerCol>
					</Row>

					<Row>
						<div className="col-sm-6">
							<Row>
								<ContainerCol className="col-sm-12">
									<PaginationLabels>
										{this.state.pagination.primaraFilaPagina} a {this.state.pagination.ultimaFilaPagina} de {this.state.pagination.totalFilas}
									</PaginationLabels>
									<PaginationButtons>
										<div className="btn-group btn-group-xs" role="group">
											<button className="btn btn-default" onClick={() => this.gridMayorAnaliticoApi.paginationGoToFirstPage()}>
												<i className="fa fa-angle-double-left fa-fw"></i>Ir al inicio
											</button>
											<button className="btn btn-default" onClick={() => this.gridMayorAnaliticoApi.paginationGoToPreviousPage()}>
												<i className="fa fa-angle-left fa-fw"></i>Anterior
											</button>
											<button className="btn btn-default" onClick={() => this.gridMayorAnaliticoApi.paginationGoToNextPage()}>
												Siguiente<i className="fa fa-angle-right fa-fw"></i>
											</button>
											<button className="btn btn-default" onClick={() => this.gridMayorAnaliticoApi.paginationGoToLastPage()}>
												Ir al final<i className="fa fa-angle-double-right fa-fw"></i>
											</button>
										</div>
									</PaginationButtons>
								</ContainerCol>
							</Row>
						</div>

						<div className="col-sm-6">
							<Row>
								<ContainerCol className="col-sm-4 pull-right">
									<LabelTotales>Crédito: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalCredito)}</LabelValorTotales>
								</ContainerCol>

								<ContainerCol className="col-sm-4 pull-right">
									<LabelTotales>Débito: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.totalDebito)}</LabelValorTotales>
								</ContainerCol>
							</Row>
						</div>
					</Row>
				</CuerpoForm>

				<ModalResponsive open={this.state.isModalAsientoVisible} onClose={() => this.setState({isModalAsientoVisible:false})}>
					<ModalContainer>
						<Row>
							<ContainerCol className='col-sm-12'>
								<h4>Asiento contable</h4>
								<Hr />
							</ContainerCol>
						</Row>
						<Row>
							<ContainerCol className="col-sm-12">
								<Row>
									<ContainerCol className="col-sm-4">
										<LabelForm>Asiento:</LabelForm> <ValueForm>{this.state.asiento_movimiento}</ValueForm>
									</ContainerCol>

									<ContainerCol className="col-sm-4">
										<LabelForm>Tipo:</LabelForm> <ValueForm>{this.state.asiento_tipo}</ValueForm>
									</ContainerCol>

									<ContainerCol className="col-sm-4">
										<LabelForm>Comprobante:</LabelForm> <ValueForm>{this.state.asiento_comprobante}</ValueForm>
									</ContainerCol>
								</Row>

								<Row>
									<ContainerCol className="col-sm-4">
										<LabelForm>Fecha:</LabelForm> <ValueForm>{this.state.asiento_fecha}</ValueForm>
									</ContainerCol>

									<ContainerCol className="col-sm-4">
										<LabelForm>Estado:</LabelForm> <ValueForm>{this.state.asiento_estadoLabel}</ValueForm>
									</ContainerCol>

									<ContainerCol className="col-sm-4">
										<LabelForm>Usuario:</LabelForm> <ValueForm>{this.state.asiento_usuario}</ValueForm>
									</ContainerCol>
								</Row>

								<Row>
									<ContainerCol className="col-sm-12">
										<LabelForm>Detalle:</LabelForm> <ValueForm>{this.props.asientoContable.Descripcion}</ValueForm>
									</ContainerCol>
								</Row>

								<Row>
									<ContainerCol className="col-sm-12">
										<AgGridRender
											altura='270px'
											data={this.state.asiento_data}
											columnas={this.state.asiento_columnDefs}
											onGridReady={this.onGridAsientoReady}
											gridOptions={this.gridAsientoOptions}
										/>
									</ContainerCol>
								</Row>

								<Row>
									<ContainerCol className="col-sm-3 pull-right">
										<LabelTotales>Crédito: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.asiento_totalHaber)}</LabelValorTotales>
									</ContainerCol>

									<ContainerCol className="col-sm-3 pull-right">
										<LabelTotales>Débito: </LabelTotales> <LabelValorTotales>{formatearNumeroDecimal(this.state.asiento_totalDebe)}</LabelValorTotales>
									</ContainerCol>
								</Row>
							</ContainerCol>
						</Row>
						<Row>
							<ContainerCol className='col-sm-12'>
								<div className="btn-group btn-group-sm">
									<button type='button' className='btn btn-default' onClick={this.imprimirAsiento}>
										<i className='fa fa-print fa-fw'></i>Imprimir asiento
									</button>
									<button type='button' className='btn btn-default' onClick={this.imprimirComprobante}>
										<i className='fa fa-print fa-fw'></i>Imprimir comprobante
									</button>
								</div>
							</ContainerCol>
						</Row>  
					</ModalContainer>
				</ModalResponsive>
			</ContenedorForm>
		);
	}
}

const mapStateToProps = ((state) => {
	return {
		isVisibleLoading: state.ui.isVisibleLoading,		
		permiso: state.sesion.valoresSesionForm.Permiso,
		cuentaContable_sel1: state.contabilidad.cuentasContables_sel[0]===undefined?null:state.contabilidad.cuentasContables_sel[0].cuenta,
		cuentaContable_sel2: state.contabilidad.cuentasContables_sel[1]===undefined?null:state.contabilidad.cuentasContables_sel[1].cuenta,
		asientoContable: state.contabilidad.asientoContable,
	};
});
  
const mapDispatchToProps = ((dispatch) => {  
	return bindActionCreators({
		cambiar_VisualizacionLoading,
		generar_LogAuditoriaIngresoForm,
		generar_LogAuditoriaSalidaForm,
		seleccionar_CuentaContable,
		cargarAsiento
	}, dispatch)
});
  
export default connect (mapStateToProps, mapDispatchToProps)(FormCon02);